import { getXUserKey } from '@/plugins/account'
export default class Password {
    
    current_password = null
    password = null
    password2 = null
    login_hash = null

    constructor(current_password, password, password2) {
        this.current_password = current_password
        this.password = password
        this.password2 = password2
        this.login_hash = getXUserKey()
    }
}